import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "default-src-form mt-3" }
const _hoisted_5 = { class: "d-sm-flex flex-wrap gap-3 row" }
const _hoisted_6 = { class: "position-relative mb-2 mb-sm-0 col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }

import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useCategoryStore } from "@/stores/master/category-store";
import { mapOptionMultiselectWithAll } from "@/utils/helper";
import { ref } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsFilter',
  emits: ["searchByQuery"],
  setup(__props, { emit: __emit }) {

const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const listCategories = ref<any>();
const listGroupCategories = ref<any>();
const category = ref();
const groupCategory = ref();
const search = ref("");

const loadListCategory = async () => {
  const { success, message } = await categoryStore.dispatchGetCategories(1, 99);
  if (success) {
    listCategories.value = mapOptionMultiselectWithAll(
      await categoryStore.categories.items
    );
  }
};

const loadListGroupCategory = async (idCategory = "") => {
  let queryParam = "";
  if (idCategory != "") {
    queryParam = "&category_id=" + idCategory;
  }

  const { success, message } =
    await groupCategoryStore.dispatchGetCategoryGroups(1, 99, queryParam);
  if (success) {
    listGroupCategories.value = mapOptionMultiselectWithAll(
      await groupCategoryStore.categoryGroups.items
    );
  }
};

loadListCategory();
loadListGroupCategory();

const emit = __emit;

const buildQuery = async () => {
  let queryTemp = "";

  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value;
  }

  if (
    category.value != undefined &&
    groupCategory.value != "" &&
    category.value?.value != "All"
  ) {
    const { success } = await categoryStore.dispatchDetail(
      category.value?.value
    );
    if (success) {
      queryTemp =
        queryTemp +
        "&category_code=" +
        (await categoryStore.category.data.code);
    }
  }

  if (
    groupCategory.value != "" &&
    category.value != "" &&
    groupCategory.value?.value != "All"
  ) {
    const { success } = await groupCategoryStore.dispatchDetail(
      groupCategory.value?.value
    );
    if (success) {
      queryTemp =
        queryTemp +
        "&group_category_code=" +
        (await groupCategoryStore.categoryGroup.data.code);
    }
  }

  emit("searchByQuery", queryTemp);
};

const handleChooseCategory = async () => {
  groupCategory.value = "";
  await loadListGroupCategory(category.value?.value);
  buildQuery();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "fs-16 fw-medium mb-sm-0" }, "Filter", -1)),
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control rounded-1",
                placeholder: "Search here",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                onKeyup: buildQuery
              }, null, 544), [
                [_vModelText, search.value]
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18" }, " search ", -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(vSelect), {
                options: listCategories.value,
                name: "category",
                modelValue: category.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category).value = $event)),
                placeholder: "Choose Category",
                onClose: handleChooseCategory
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(vSelect), {
                options: listGroupCategories.value,
                name: "groupCategory",
                modelValue: groupCategory.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((groupCategory).value = $event)),
                placeholder: "Choose Group Category",
                onClose: buildQuery
              }, null, 8, ["options", "modelValue"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})